var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconClose = function SvgIconClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.257 97.3583C103.038 96.5772 103.038 95.3108 102.257 94.5296L59.2275 51.4914L102.259 8.46887C103.04 7.6879 103.04 6.4217 102.259 5.64073L97.3579 0.740989C96.5767 -0.0399823 95.3103 -0.0399819 94.5292 0.740989L51.4996 43.762L8.48681 0.740629C7.70584 -0.0404966 6.43963 -0.0404961 5.65866 0.74063L0.758924 5.64134C-0.0220469 6.42247 -0.0220467 7.68892 0.758924 8.47005L43.7702 51.4899L0.740141 94.5114C-0.0409849 95.2924 -0.0409843 96.5586 0.740142 97.3395L5.64085 102.239C6.42198 103.02 7.68843 103.02 8.46956 102.239L51.4981 59.2193L94.5293 102.259C95.3103 103.04 96.5765 103.04 97.3575 102.259L102.257 97.3583Z",
    fill: "#EC4B3F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_close.63d19fa6.svg";
export { ForwardRef as ReactComponent };